import { createSelector } from 'reselect';
import { ApiCenter } from 'mss-component-library';

const selectCenter = state => state.default.configuration.center;

export const selectedCenter = createSelector(
  [selectCenter],
  (center: ApiCenter) => center,
);
